import { render, staticRenderFns } from "./PlatformElderByAssessmentByAge.vue?vue&type=template&id=cfbef95a&scoped=true&"
import script from "./PlatformElderByAssessmentByAge.vue?vue&type=script&lang=js&"
export * from "./PlatformElderByAssessmentByAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbef95a",
  null
  
)

export default component.exports